import React, { useState } from "react";

const InputComp = ({
  label,
  placeHolder,
  handleChange,
  type = "text",
  value,
  classes = "",
  labelClasses = "",
  inputKey,
  required,
  regex,
}) => {
  const [isInvalid, setIsInvalid] = useState(false);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    handleChange(inputKey, inputValue);

    // Validation check
    if (required && (!inputValue || (regex && !regex.test(inputValue)))) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);
    }
  };

  return (
    <div className="flex flex-col">
      <label className={labelClasses}>{label}</label>
      <input
        type={type}
        value={value}
        placeholder={placeHolder}
        className={`w-full rounded-[10px] border p-4 ${
          isInvalid ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
        } ${classes}`}
        onChange={handleInputChange}
      />
      {isInvalid && (
        <p className="text-red-500 text-sm mt-1">
          {label} is required and must be valid.
        </p>
      )}
    </div>
  );
};

export default InputComp;
